module.exports = __webpack_public_path__ + "img/R2_4_research_matsumoto2.b0673380.png";